import { HubConnection } from "@microsoft/signalr";
import { SignalRContext } from "index";
import React from "react";

export const useSignalR = () => React.useContext<HubConnection>(SignalRContext);